import styled from "styled-components"
import colors from "~constants/colors"

export const TopCardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 16px;
  height: 157px;

  .topCardNumber {
    font-size: 50px;
    margin: 0;
  }
`

interface CardProps {
  padding?: string
}

export const Card = styled.div<CardProps>`
  background-color: ${colors.white};
  border: 1px solid ${colors.gray2};
  border-radius: 10px;
  flex-grow: 1;
  padding: ${props => (props.padding ? props.padding : 30)}px;

  &.min-padding {
    padding: 30px 15px;
  }
`

export const CardHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${colors.gray9};
  margin-bottom: 20px;
  padding: 0 0 15px 0;
`

export const CardTitle = styled.span`
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 10px;
  max-width: 300px;
  text-align: center;
`
